import React, { useState, useEffect } from 'react'
import { UIProvider } from './contexts/UIContext'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Login from './pages/Login'
import Sidebar from './components/Sidebar'
import Dashboard from './pages/Dashboard'
import Auditoria from './pages/Auditoria'
import Clientes from './pages/Clientes'
import Usuarios from './pages/Usuarios'
import Mapa from './pages/Mapa'
import Cercas from './pages/Cercas'
import Alertas from './pages/Alertas'
import Replay from './pages/Replay'
import Pontos from './pages/Pontos'
import ConfigAlertas from './pages/ConfigAlertas'
import Manutencao from './pages/Manutencao'
import Abastecimento from './pages/Abastecimento'
import AreasVisitadas from './pages/AreasVisitadas'
import Grupos from './pages/Grupos'
import Chips from './pages/Chips'
import Planos from './pages/Planos'
import AtivosDesinstalados from './pages/AtivosDesinstalados'
import ComEmpresaSuper from './components/ComEmpresaSuper'
import FechamentoMensal from './pages/FechamentoMensal'
import EmailConfig from './pages/EmailConfig'
import CalendarioLicenciamento from './pages/CalendarioLicenciamento'
import EmailLogs from './pages/EmailLogs'
import Licencas from './pages/Licencas'
import IAAdmin from './pages/IAAdmin'
import IAMeuUso from './pages/IAMeuUso'
import Manu from './pages/Manu'
import Viagens from './pages/Viagens'
import Pneus from './pages/Pneus'
import LancamentosManuais from './pages/LancamentosManuais'
import MeusVeiculos from './pages/MeusVeiculos'
import { paginaInicialLimitada } from './utils/usuarioLimitado'
import Contratos from './pages/Contratos'
import WhatsApp from './pages/WhatsApp'
import Motoristas from './pages/Motoristas'
import Rastreadores from './pages/Rastreadores'
import Relatorios from './pages/Relatorios'
import Ativos from './pages/Ativos'
import Comandos from './pages/Comandos'
import AlertasConducaoPopup from './components/AlertasConducaoPopup'
import { podeVer } from './components/Sidebar'
import MarcasModelos from './pages/MarcasModelos'
import TiposCombustivel from './pages/TiposCombustivel'
import ChecklistModelos from './pages/ChecklistModelos'
import ChecklistRespostas from './pages/ChecklistRespostas'
import ChecklistConformidade from './pages/ChecklistConformidade'

function AppContent() {
  const [trocandoSenha, setTrocandoSenha] = useState(false)
  const [confirmaSenha, setConfirmaSenha] = useState('')
  const [novaSenha, setNovaSenha] = useState('')
  const { usuario, loading, primeiroAcesso, setPrimeiroAcesso } = useAuth()
  const [pagina, setPagina] = useState('dashboard')
  // link de redefinicao de senha (?redefinir=...): mostra a tela de login mesmo que ja exista uma sessao aberta neste navegador
  const [linkRedefinir, setLinkRedefinir] = useState(() => { try { return window.location.search.includes('redefinir=') } catch { return false } })
  // usuario LIMITADO (so lancamentos manuais / tela simples de veiculos) abre direto na tela dele: o dashboard nao faz parte do acesso dele
  useEffect(() => { const p = paginaInicialLimitada(usuario); if (p) setPagina(p) }, [usuario])
  const [replayParams, setReplayParams] = useState<any>(null)

  useEffect(() => {
    const handler = (e: any) => {
      setReplayParams(e.detail)
      setPagina('replay')
    }
    window.addEventListener('navegarReplay', handler)
  return () => window.removeEventListener('navegarReplay', handler)
  }, [])

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#0d1b2e' }}>
      <div style={{ color:'#0ea5e9', fontSize:18 }}>Carregando...</div>
    </div>
  )

  if (!usuario || linkRedefinir) return <Login aoConcluir={() => setLinkRedefinir(false)} />

  const renderPagina = () => {
    switch (pagina) {
      case 'dashboard':     return <Dashboard />
      case 'mapa':          return <Mapa />
      case 'replay':        return <Replay params={replayParams} />
      case 'chips':          return <Chips />
      case 'planos':          return <Planos />
      case 'ativos_desinstalados': return <AtivosDesinstalados />
      case 'fechamento':      return <FechamentoMensal />
      case 'email-config':    return <EmailConfig />
      case 'calendario-licenciamento': return <CalendarioLicenciamento />
      case 'auditoria': return <Auditoria/>
      case 'email-logs':      return <EmailLogs />
      case 'licencas':        return <Licencas />
      case 'ia_admin':        return <IAAdmin />
      case 'ia_meu_uso':      return <IAMeuUso />
      case 'manu':            return <Manu />
      case 'viagens':         return <Viagens />
      case 'lancamentos':     return <ComEmpresaSuper chave="lancamentos"><LancamentosManuais /></ComEmpresaSuper>
      case 'meus_veiculos':   return <ComEmpresaSuper chave="meus_veiculos"><MeusVeiculos /></ComEmpresaSuper>
      case 'pneus':           return <Pneus />
      case 'contratos':       return <Contratos />
      case 'whatsapp':        return <WhatsApp />
      case 'grupos':          return <Grupos />
      case 'motoristas':      return <Motoristas />
      case 'rastreadores':     return <Rastreadores />
      case 'relatorios':     return <Relatorios />
      case 'ativos':        return <Ativos />
      case 'marcas_modelos': return <MarcasModelos />
      case 'tipos_combustivel': return <TiposCombustivel />
      case 'checklist_modelos': return <ChecklistModelos />
      case 'checklist_respostas': return <ChecklistRespostas />
      case 'checklist_conformidade': return <ChecklistConformidade />
      case 'cercas':        return <Cercas />
      case 'alertas':       return <Alertas />
      case 'pontos':        return <Pontos />
      case 'config_alertas':return <ConfigAlertas />
      case 'manutencao':    return <Manutencao />
      case 'abastecimento':  return <Abastecimento />
      case 'areas_visitadas': return <AreasVisitadas />
      case 'clientes':      return <Clientes />
      case 'usuarios':      return <Usuarios />
      case 'comandos':      return <Comandos />
      default: return (
        <div style={{ padding:32, display:'flex', alignItems:'center', justifyContent:'center', height:'100%', flexDirection:'column', gap:12 }}>
          <div style={{ fontSize:48 }}>🚧</div>
          <div style={{ fontSize:18, fontWeight:600 }}>Em desenvolvimento</div>
          <div style={{ fontSize:13, color:'#64748b' }}>Este módulo será implementado em breve</div>
        </div>
      )
    }
  }

  const trocarSenhaInicial = async () => {
    if (!novaSenha || novaSenha.length < 8) return alert('A senha deve ter no mínimo 8 caracteres')
    if (!/[A-Za-z]/.test(novaSenha) || !/\d/.test(novaSenha)) return alert('A senha precisa ter letras e números')
    if (novaSenha !== confirmaSenha) return alert('Senhas não conferem')
    setTrocandoSenha(true)
    try {
      const token = localStorage.getItem('moobi_token')
      const resp = await fetch(`${process.env.REACT_APP_API_URL||'http://localhost:3001/api'}/auth/definir-senha-inicial`, {
        method:'POST',
        headers:{'Content-Type':'application/json','Authorization':`Bearer ${token}`},
        body:JSON.stringify({nova_senha:novaSenha})
      })
      const dados = await resp.json().catch(()=>({}))
      if (!resp.ok) { alert(dados.erro || 'Não foi possível trocar a senha'); return }     // antes mostrava "sucesso" mesmo quando o servidor recusava
      if (dados.token) localStorage.setItem('moobi_token', dados.token)
      setPrimeiroAcesso(false)
      setNovaSenha(''); setConfirmaSenha('')
      alert('Senha alterada com sucesso!')
    } catch { alert('Erro ao trocar senha') }
    finally { setTrocandoSenha(false) }
  }

  return (
    <>
    {primeiroAcesso && (
      <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.8)',zIndex:9999,
        display:'flex',alignItems:'center',justifyContent:'center'}}>
        <div style={{background:'#0d1b2e',borderRadius:12,padding:32,width:400,
          border:'1px solid #2d4166',boxShadow:'0 20px 60px rgba(0,0,0,0.5)'}}>
          <h2 style={{fontSize:18,fontWeight:700,marginBottom:8}}>🔑 Bem-vindo!</h2>
          <p style={{fontSize:13,color:'#64748b',marginBottom:20}}>
            Este é seu primeiro acesso. Por segurança, defina uma nova senha.
          </p>
          <div style={{marginBottom:12}}>
            <label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Nova senha</label>
            <input type="password" value={novaSenha} onChange={e=>setNovaSenha(e.target.value)}
              placeholder="Mínimo 8 caracteres, com letras e números"
              style={{width:'100%',padding:'10px 12px',borderRadius:8,border:'1px solid #2d4166',
                background:'#1e2f4a',color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}} />
          </div>
          <div style={{marginBottom:20}}>
            <label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Confirmar senha</label>
            <input type="password" value={confirmaSenha} onChange={e=>setConfirmaSenha(e.target.value)}
              placeholder="Repita a senha"
              style={{width:'100%',padding:'10px 12px',borderRadius:8,border:'1px solid #2d4166',
                background:'#1e2f4a',color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}} />
          </div>
          <button onClick={trocarSenhaInicial} disabled={trocandoSenha}
            style={{width:'100%',padding:'12px',borderRadius:8,border:'none',cursor:'pointer',
              background:'#0ea5e9',color:'#fff',fontSize:14,fontWeight:600}}>
            {trocandoSenha?'Salvando...':'✅ Definir senha e entrar'}
          </button>
        </div>
      </div>
    )}
    <div style={{ display:'flex', height:'100vh', overflow:'hidden' }}>
      <Sidebar pagina={pagina} setPagina={setPagina} />
      {usuario && usuario.perfil !== 'superadmin' && podeVer('alertas', usuario) && <AlertasConducaoPopup aoAbrirAlertas={() => setPagina('alertas')} />}
      <main style={{ flex:1, overflow:'hidden', display:'flex', flexDirection:'column' }}>
        {renderPagina()}
      </main>
    </div>
  )
  </>
  )
}

export default function App() {
  return <UIProvider><AuthProvider><AppContent /></AuthProvider></UIProvider>
}
